// removed by extract-text-webpack-plugin
module.exports = {"content":"style_content--16fUE"};


//////////////////
// WEBPACK FOOTER
// ./styles/style.scss
// module id = 175
// module chunks = 16